import { render, staticRenderFns } from "./recordingItem.vue?vue&type=template&id=70a4ab46&scoped=true"
import script from "./recordingItem.vue?vue&type=script&lang=js"
export * from "./recordingItem.vue?vue&type=script&lang=js"
import style0 from "./recordingItem.vue?vue&type=style&index=0&id=70a4ab46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a4ab46",
  null
  
)

export default component.exports